<template>
<div class="chapter">
<div class="inner_page">
<p class="sp1" id="ack"> </p>
<p class="BMH-1"><span href="#/xhtml/contents#c_Ack" title="Link target outside of Sample"><span class="ePub-B">ACKNOWLEDGMENTS</span></span></p>
<p class="TNI-3">The authors would like to acknowledge their debts to Snorri Sturluson (1179–1241), the author of the <span class="ePub-I">Prose Edda;</span> the Viking Answer Lady and her fascinating and tremendously helpful website, <a href="http://www.vikinganswerlady.com" target="_blank">www.vikinganswerlady.com</a>; Dr. Robert J. Hasenfratz (for teaching Bear Anglo-Saxon all these years ago); Mitchell and Robinson’s <span class="ePub-I">A Guide to Old English;</span> Jennifer Jackson, agent beyond compare; and Beth Meacham, for being the extraordinary editor that she is. </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// acknowledgments.vue?147a7ae9